import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';

import { MdbCollapseModule, MdbModalRef, MdbSelectModule } from 'mdb5-adapted';

import { LMSConstantsService } from '@lmsConstants';
import { RatesAndFeesModel } from '@lmsModels';
import { RatesAdnFeesService } from '@lmsrestServices';
import { LmsModalFrameComponent } from '@lmsSharedUI';

@Component({
  selector: 'app-add-loan-type',
  templateUrl: './add-loan-type.component.html',
  styleUrls: ['./add-loan-type.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MdbCollapseModule,
    MdbSelectModule,
    LmsModalFrameComponent,
  ],
})
export class AddLoanTypeComponent implements OnInit {
  ratesAndFeesModel = {} as RatesAndFeesModel;
  addLoanTypeForm: FormGroup;
  submitted = false;
  loanTypeData: any;
  lstLoanTypeData: any[] = [];
  lstmyBenTier = this.lmsConstantService.getLMSConstant('MYBENEFIT_TIER');
  panelOpenState = false;

  constructor(
    public dialogRef: MdbModalRef<AddLoanTypeComponent>,
    public ratesAndFeesService: RatesAdnFeesService,
    private fb: FormBuilder,
    private changeDetector: ChangeDetectorRef,
    private lmsConstantService: LMSConstantsService
  ) {}

  ngOnInit(): void {
    this.ratesAndFeesModel = new RatesAndFeesModel();

    //ADDS loanTypeInfo to the array lstLoanTypeData
    this.addLoanTypeForm = this.fb.group({
      //PRODUCT DETAILS
      code: [this.ratesAndFeesModel.code],
      description: [this.ratesAndFeesModel.description],
      type: [this.ratesAndFeesModel.type],
      regulatoryType: [this.ratesAndFeesModel.regulatoryType],
      minimumLoan: [this.ratesAndFeesModel.minimumLoan, [Validators.required]],
      maximumLoan: [this.ratesAndFeesModel.maximumLoan, [Validators.required]],

      interestRate1st: [this.ratesAndFeesModel.interestRate1st, [Validators.required]],
      interestRateOther: [this.ratesAndFeesModel.interestRateOther, [Validators.required]],
      initFeeBelow1000: [this.ratesAndFeesModel.initFeeBelow1000],
      initFeeFirst1000: [this.ratesAndFeesModel.initFeeFirst1000],
      initiationFee: [this.ratesAndFeesModel.initiationFee, [Validators.required]],
      initiationCap: [this.ratesAndFeesModel.initiationCap, [Validators.required]],
      includeVatInCalculation: [this.ratesAndFeesModel.includeVatInCalculation],

      myBenefits: [this.ratesAndFeesModel.myBenefits, [Validators.required]],

  // The template binds to `mybenefitsTier`; ensure the control is present
  mybenefitsTier: [this.ratesAndFeesModel.mybenefitsTier || null, []],

      factor1stLoan: [this.ratesAndFeesModel.factor1stLoan, [Validators.required]],
      factorOtherLoan: [this.ratesAndFeesModel.factorOtherLoan, [Validators.required]],
      factorUpTo850: [this.ratesAndFeesModel.factorUpTo850, [Validators.required]],
      factorUpTo1000: [this.ratesAndFeesModel.factorUpTo1000, [Validators.required]],
      initServiceFeeCap: [this.ratesAndFeesModel.initServiceFeeCap, [Validators.required]],
      term: [this.ratesAndFeesModel.term, [Validators.required]],
      monthlyServiceFee: [this.ratesAndFeesModel.monthlyServiceFee, [Validators.required]],
      maxDays: [this.ratesAndFeesModel.maxDays, [Validators.required]],

      calculationType: [this.ratesAndFeesModel.calculationType],
      includeInInterestCalc: [this.ratesAndFeesModel.includeInInterestCalc],
      includeVatInCalc: [this.ratesAndFeesModel.includeVatInCalc],
    });
  }

  public lstRegulatory: any[] = [
    { value: 'ShortTerm', description: 'Short Term' },
    { value: 'Unsecured', description: 'Unsecured' },
  ];

  ngAfterContentChecked(): void {
    this.changeDetector.detectChanges();
  }

  saveLoanType() {
    this.submitted = true;
    if (this.addLoanTypeForm.invalid) {
      console.log('Form fields are null or empty...');
      this.submitted = false;
      return;
    }
    return this.dialogRef.close(this.ratesAndFeesModel);
  }

  close() {
    this.dialogRef.close();
  }

  get validateRatesAndFeesValues() {
    return this.addLoanTypeForm.controls;
  }
}
